angular.module('iSkanerAztecs.base', []);